var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfiles = function SvgProfiles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "m27.735 18.56-1.898-1.898a7.917 7.917 0 0 1-14.184-6.947l-.447-.49-5.639 9.106-4.641-6.982 1.318-.877L5.52 15.4l5.444-8.793 1.479 1.624a7.917 7.917 0 0 1 14.088 6.886l1.154 1.154 8.15-8.89 1.167 1.07zM14.1 8.653l3.403 3.95 3.905-3.735 3.925 3.814v-.015a6.333 6.333 0 0 0-11.233-4.014m10.201 7.48a6.333 6.333 0 0 1-11.6-4.142l4.646 5.144 4.012-3.838z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M6.334 28.028v3.638h25.333v-3.638c0-2.426-6.53-5.862-12.666-5.862S6.334 25.602 6.334 28.028"
  })));
};
export default SvgProfiles;